export default class Maths {
  static round(nbr, decimals = 2) {
    return Math.round(nbr * Math.pow(10, decimals)) / Math.pow(10, decimals);
  }
}
